<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-tips" v-if="type != 'add'">
        <img src="@/assets/images/basicBusiness/tips2.png" alt="" />
        <div>物流信息仅支持1次更正，请仔细填写并核对</div>
      </div>
      <div class="posi-over">
        <div class="item">
          <div class="item-title xin">发货方式</div>
          <div class="item-input">
            <el-select
              v-model="fromData.sendway"
              filterable
              placeholder="请选择发货方式"
            >
              <el-option
                v-for="item in sendwayArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="item" v-if="fromData.sendway==1">
          <div class="item-title xin">选择物流公司</div>
          <div class="item-input">
            <el-select
              v-model="fromData.expressname"
              filterable
              placeholder="请选择物流公司"
            >
              <el-option
                v-for="item in nameArr"
                :key="item.values"
                :label="item.values"
                :value="item.values"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="item" v-if="fromData.sendway==1">
          <div class="item-title xin">填写物流单号</div>
          <div class="item-input">
            <input
              type="text"
              v-model="fromData.expressno"
              placeholder="请输入物流单号"
            />
          </div>
        </div>
        <div class="item">
          <div class="item-title">填写物流备注</div>
          <div class="item-input">
            <input
              type="text"
              v-model="fromData.expressremark"
              placeholder="请输入物流备注"
            />
          </div>
        </div>
      </div>

      <div class="posi-btn">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
          <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      fromData: {
        id: "",
        expressname: "",
        expressno: "",
        expresscode: "",
        expressremark:"",
        sendway:1
      },
      nameArr: [],
      type: "add",
      sendwayArr:[
        {
          id:1,
          name:"物流快递"
        },
        {
          id:2,
          name:"虚拟发货"
        }
      ]
    };
  },
  mounted() {
    this.dictionaryGetexpress();
  },
  methods: {
    async dictionaryGetexpress() {
      let res = await this.$api.dictionaryGetexpress();
      if (res.code == 1) {
        this.nameArr = res.data;
      }
    },
    //提交
    async handleSubmit() {
      this.nameArr.forEach((item) => {
        if (item.values == this.fromData.expressname) {
          this.fromData.expresscode = item.bianhao;
        }
      });
      if (this.type == "add") {
        let res = await this.$api.shopOrdersend({
          ...this.fromData,
        });

        if (res.code == 1) {
          this.$message.success(res.msg);
          let obj = {
            flag: false,
            submitFlag: true,
          };
          this.$emit("deliveryCell", obj);
        }
      } else {
        let res = await this.$api.shopOrderresend({
          ...this.fromData,
        });

        if (res.code == 1) {
          this.$message.success(res.msg);
          let obj = {
            flag: false,
            submitFlag: true,
          };
          this.$emit("deliveryCell", obj);
        }
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("deliveryCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.fromData.expressname = newVal.item.expressname;
          this.fromData.expressno = newVal.item.expressno;
          this.fromData.expresscode = newVal.item.expresscode;
          this.fromData.expressremark = newVal.item.expressremark;
          this.fromData.sendway = newVal.item.sendway? Number(newVal.item.sendway):newVal.item.sendway;
          this.fromData.id = newVal.item.id;
          this.type = newVal.type;
        }
      },
      deep: true,
    },
  },
};
</script>
          <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 600px;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  padding-bottom: 5vh;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .posi-tips {
    border: 1px solid #fdf1ba;
    background: #fef6cc;
    height: 40px;
    width: calc(100% - 20px);
    display: flex;
    align-items: center;
    margin: 10px;
    padding: 12px 23px;
    img {
      width: 12px;
      height: auto;
      margin-right: 15px;
    }
  }
  /deep/.posi-over {
    padding: 4vh 0 5vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .item {
      font-size: 14px;
      margin-bottom: 30px;
      .item-title {
        display: flex;
        
      }
      .xin {
        &::after {
          display: block;
          content: "*";
          color: #ff3b30;
        }
      }
      .item-input {
        margin-top: 11px;
        input {
          width: 23.148vw;
          height: 52px;
          line-height: 52px;
          background-color: #f2f2f7;
          padding-left: 2.315vw;
          border: none;
          outline: none;
          border-radius: 5px;
        }
      }
    }
  }
  .posi-btn {
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #4a4b9d;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>